export default __webpack_public_path__ + "static/section_4_details_11-0f6b8c6d420657a8b037b15d91bba24f.png";